import { API_URL } from "env";
import { toast } from "react-toastify";

async function updateFeature(
    featureId: number,
    updatedData: { name?: string; description?: string; key?: string; number?: number }
): Promise<boolean> {
    const token = localStorage.getItem("token");
    try {
        if (!token) throw new Error("No token found");
        const response = await fetch(`${API_URL}api/v1/be/features/${featureId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(updatedData),
        });
        if (!response.ok) {
            const data = await response.json();
            toast.error(data.message || "Failed to update feature");
        }
        toast.success("Feature updated successfully");
        return true;
    } catch (error) {
        console.error("Error updating feature:", error);
        return false;
    }
}

export default updateFeature;